import { render, staticRenderFns } from "./EditResponsable.vue?vue&type=template&id=6313a106&scoped=true&"
import script from "./EditResponsable.vue?vue&type=script&lang=js&"
export * from "./EditResponsable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313a106",
  null
  
)

export default component.exports